// removed by extract-text-webpack-plugin
module.exports = {"Burger":"Burger__Burger__3K4F-","styleScroll":"Burger__styleScroll__38X-d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.css
// module id = 304
// module chunks = 3